import React from "react";
import "./Goals.css";
import Resources from "../../../Resources/Resources";
import {Col, Container, Modal, Row} from "react-bootstrap";
import {APP_SECTION, PAGES} from "../../../scripts/constants";
import {mygaSession} from "../../../scripts/myga-session";
import {saveApplication} from "../../../scripts/sync-manager";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {PageManager} from "../../../scripts/page-manager";
import {
  isPaymentScenarioValid,
  isReplacementOrCD,
  reconcileParties,
  reconcilePaymentsForProducts
} from "../../../scripts/validation";
import Question from "../../../components/Questions/Question";
import {MM_PRODUCT_DTO} from "../../../scripts/myga-model";

class Goals extends React.Component {

  constructor(props) {
    super(props);

    // Load the component state from the current application
    this.state = {
      goals: {...mygaSession.getCurrentAppGoals()},
      finances: {...mygaSession.getCurrentAppFinances()},
      errorMessage:'',
      showEarlyFundsModal: false
    };
  
  }

  onBackPressed = async () => {
    await this.saveApplication()
  }

  onNextPressed = async () => {
    await this.saveApplication()
  }

  saveApplication = async () => {
    
    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.goals,this.state.goals);
    await saveApplication(APP_SECTION.goals);
  
    mygaSession.setCurrentAppSectionData(APP_SECTION.finances,this.state.finances);
    await saveApplication(APP_SECTION.finances);
  
    // 2021.09.08.ADivelbiss - Check to see if payments should be cleared.
    // Do this after regular data are saved
    const nextProductDTOs = reconcilePaymentsForProducts();
    if (nextProductDTOs) {
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs);
      await saveApplication(APP_SECTION.products)
    }
    
    // 2021.11.11.ADivelbiss - need to reconcile parties at this point if the
    // user comes back to this page and make different selections.
    const parties = reconcileParties();
    if (parties) {
      mygaSession.setCurrentAppParties(parties);
      await saveApplication(APP_SECTION.parties);
      // 2022.05.19.ADivelbiss - currently assume all parties applied to all selected products.
      const nextProductDTOs = [...mygaSession.getCurrentAppProductDTOs()];
      nextProductDTOs.forEach(dto=>dto[MM_PRODUCT_DTO.parties]=parties);
      mygaSession.setCurrentAppProductDTOs(nextProductDTOs)
      await saveApplication(APP_SECTION.products);
    }
    
  };
  
  handleChange = (section) => (field) => (e) => {
    let data = this.state[section];
    data[field] = e.target && e.target.value !== undefined ? e.target.value : e;
    let nextState = {errorMessage:''};
    nextState[section] = data;
    this.setState(nextState);
  };
  
  validate = () => {
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      this.setState({
        errorMessage: MYGAStrings.Goals_ErrorMissingInformation
      });
      return false;
    }
    
    return true;
  };

  render() {
    
    return (
        <AppContentWrapper
            onBackPressed={this.onBackPressed}
            onNextPressed={this.onNextPressed}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>

          <form className={'needs-validation'}
                         ref={(form) => {
                           this.pageForm = form;
                         }}>
            <Container className={'pb-3'}>
              <Question
                containerClass={'pb-4 pl-4 pl-md-5'}
                data={this.state.goals}
                question={PageManager.getQuestionByName('needsEarlyAccess')}
                onChange={this.handleChange('goals')}/>

              <Question
                containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
                data={this.state.goals}
                question={PageManager.getQuestionByName('isReplacement')}
                onChange={this.handleChange('goals')}/>

              <Question
                containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
                data={this.state.goals}
                question={PageManager.getQuestionByName('willStopPayments')}
                onChange={this.handleChange('goals')}/>

              <Question
                containerClass={'pb-4 mt-2 pl-4 pl-md-5'}
                data={this.state.goals}
                question={PageManager.getQuestionByName('hasSourceOfFundsPenalty')}
                onChange={this.handleChange('goals')}/>

              <Question
                  containerClass={'pb-2 mt-4 pl-4 pl-md-5'}
                  questionClass={'text-xs-left text-sm-center'}
                  question={PageManager.getQuestionByName('sourceOfFunds')}
                  data={this.state.finances}
                  onChange={this.handleChange('finances')}
              />
  
              <Question
                  containerClass={'pb-2 mt-4 pl-4 pl-md-5'}
                  questionClass={'text-xs-left text-sm-center'}
                  question={PageManager.getQuestionByName('sourceOfFundsNonQualOrIRA')}
                  data={this.state.finances}
                  onChange={this.handleChange('finances')}
              />

            </Container>
          </form>

          <Modal
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showCallForHelpMessage}
              onHide={()=>{
                this.setState({
                  showCallForHelpMessage: false
                })
              }}
          >

            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  {Resources.Strings.Goals_ErrorCallForHelp}
                </Col>
              </Row>

            </Modal.Body>

          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showEarlyFundsModal}
            onHide={()=>{
              this.setState({
                showEarlyFundsModal: false
              })
            }}
          >
            <Modal.Header closeButton/>
            <Modal.Body>
              {Resources.Strings.Goals_InfoEarlyAccess}
            </Modal.Body>
          </Modal>

        </AppContentWrapper>
    );
    
  }
}

export default Goals;